import NextLink from 'next/link';

import { Link } from '@kc-console/common-ui';

import type { RouterLinkProps } from './types';

const RouterLink = (props: RouterLinkProps) => {
  return <Link<typeof NextLink> {...props} component={NextLink} />;
};

export default RouterLink;
